<template>
  <div id="articleView" >
    <article class="row">
      <header class="col s12 l11 no-float center-aligned site-max">
        <ul class="crumbs" v-if="ready">
          <li class="homeCrumb">
              <router-link class="grey-text text-darken-2" to="/"> <i class="material-icons">home</i></router-link>
          </li>
          <li>
            <router-link class="grey-text text-darken-2"
              :to="{name:'category',params:{slug:crumbCategory.slug}, query:{id:crumbCategory.id, type:hasType}}">
              {{crumbCategory.name}}
            </router-link>
          </li>
          <li>
            <span class="grey-text text-darken-2" v-html="post.title.rendered"></span>
          </li>
        </ul>

        <div class="post-image" v-if="image_src">
          <img :src="image_src" :alt="post.title.rendered">
        </div>

        <div class="clear"></div>
        <div class="page-title" 
          v-if="ready"
          v-html="post.title.rendered">
        </div>
        
      </header>
      <!--  -->
      <div class="regular-content col s12 l11 no-float center-aligned site-max" v-if="post && post.content">
        <div class="clear"></div>
        <div class="html" v-html="post.content.rendered"></div>
      </div>
      <!--  -->
      <div id="toc" ref="toc" class="active"  v-if="ready && post.acf.content">
        <div @click="$_toggleView()" class="header-bar indigo accent-3 waves-effect waves-block">Table of Contents</div>
        <div class="table-of-content">
          <div class="content" v-html="post.acf.content"></div>
        </div>
      </div>
      <!--  -->
      <section class="col s12 l9 push-l1" v-if="ready && post.acf.content">
        <div class="content" v-html="post.content.rendered"></div>
      </section>
      <!--  -->
      <documents-lists v-if="post && post.acf.doc" :data-docs="post.acf.doc"/>
      <!--  -->
      <div class="steps-actions col s12 l9 push-l1" v-if="post && post.acf.steps && post.acf.steps.length > 0">
        <div class="input-options">
          <input type="search" name="filter" ref="filter" id="filter" v-model="searchFilter">
        </div>
        <button @click="$_runPresentation('open')" class="btn indigo accent-2 waves-effect right"><i class="material-icons left">ondemand_video</i> View Slides</button>
        <div class="clear"></div>
      </div>
      <!--  -->
      <section class="col s12 l9 push-l1">
        <steps-component
          v-if="steps && steps.length > 0"
          @action="$_runPresentation($event)"
          :data-steps="steps"
        ></steps-component>
      </section>
      <!--  -->
      <section
        v-if="ready && steps && steps.length > 0"
      >
      <steps-modal
          @status="$_runPresentation($event)"
          :data-steps="modalSteps"
          :modal-status="modalStatus"
        >
        </steps-modal> 
      </section>
      <!--  -->
    </article>
  </div>
</template>
<script>/* 
import ItemLists from '@/components/ItemsList.component' */
import DocumentsLists from '@/components/hr/DocumentLists.component.vue'
import {getImageById} from '@/services/mediaService.js'
import {mapState} from 'vuex'
import contentService from '@/services/contentService'
import stepsModal from '@/components/stepsModal.component'
import stepsComponent from '@/components/steps.component'
export default {
  name:'articleView',
  components:{
    stepsComponent,
    stepsModal,
    DocumentsLists
    /* ItemLists, */
  },
  watch:{
    '$route': function() {
        this.initView()
    }
  },
  data(){
    return {
      modalStatus:'closed',
      image_src: false,
      searchValues:''
    }
  },
  mounted(){
    this.initView()
   
  },
  computed:{
    ...mapState({
      posts:state => state.all,
      categories:state => state.categories
    }),
    hasType:{
      get () {
        return this.$route.query && this.$route.query.type ?  this.$route.query.type : false
      }
    },
    post:{
      get(){
        return this.posts.find(item => item.slug === this.$route.params.slug)
      }
    },
    crumbCategory:{
      get(){
        return this.categories.find(category => category.id === this.post.categories[0])
      }
    },
    ready:{
      get(){
        const readyTest = () => {
          let hasPosts = this.post ? true : false
          let hasCats = this.categories && this.categories.length > 0 ? true : false
          return hasPosts && hasCats
        }
        return readyTest()
      }
    },
    searchFilter:{
      get(){
        return this.searchValues
      },
      set(e){
        if(e.length > 4 && e.replace(/\s/g, '').length) this.searchValues = e
        else this.searchValues = e
      }
    },
    modalSteps:{
      get(){
        return this.post && this.post.acf.steps !== null && this.post.acf.steps ? this.post.acf.steps : []
      }
    },
    steps:{
      get(){
        const createEle = (values, title) => {
         let newDiv =  document.createElement('DIV')   
         let titleDiv = document.createElement('DIV')     
          newDiv.innerHTML = values 
          titleDiv.innerHTML = title
          newDiv.append(titleDiv)
          return newDiv.textContent
        }
      return this.modalSteps.filter(step => {
        const bodySearch = createEle(step.content, step.title).toLowerCase().includes(this.searchFilter.toLowerCase())
        return bodySearch
      })

      }
    }
  },
  methods:{
    initView () {
      let type = this.$route.query  && this.$route.query.type ? this.$route.query.type : 'post'
      contentService.getByTypeAndSlug(type, this.$route.params.slug)
      .then(res=>{
        this.$store.commit('ADD_POST',res.data[0])
        this.displayImage()
        contentService.getCategoryByID(res.data[0].categories[0])
        .then(results =>{
          this.$store.commit('ADD_CATEGORY', results.data)
        })
      })
      .catch(()=>{
        window.console.log('failed fetch')
      })
    },
    async displayImage () {
        if(this.post.featured_media) {
          let {data} = await getImageById(this.post.featured_media)
          this.image_src = data.source_url
        } else this.image_src = false
    },
    $_toggleView(){
      this.$refs.toc.classList.toggle('active')
    },
    $_runPresentation(event){
      this.modalStatus = event
    },
  }

}
</script>
<style lang="scss" scoped>
#articleView {
  min-height:calc(101vh - 56px);
  @media screen and (min-width:1024px) {
    width: calc(97vw);
    padding-left:300px;
  }
  .post-image {
    width: 100%;
    margin: 16px 0;
    img {
      max-width: 100%;
    }
  }
  ul.crumbs {
    padding:0 12px; 
    margin:16px 0 0 0;
    @media screen and (min-width:1024px){
      margin: 36px 0 0 0px;
      padding: 0px;
    }
     li {
      display: inline-flex;
      padding: 0px 5px;
      line-height: 13px;
        &.homeCrumb i {
          transform: translateY(6px) !important;
        }
      a {
          &::after {
            content: 'arrow_right';
            font-family: 'Material Icons';
            font-size: 20px;
            vertical-align: middle;
            margin-left: 6px;
          }
      }
    }
  }
  .page-title {
    font-size: 24px;
    line-height: 1.5;
    margin: 12px 0px 12px 0px;
  }
  .steps-actions {
    padding-bottom: 24px !important;
    .input-options {
      width: 350px;
      @media screen and (max-width: 680px){
        width:300px;
      }
      float: left;
      &::before {
        content: 'search';
        font-family: 'Material icons';
        line-height: 39px;
        font-size: 24px;
        position: absolute;
        left: 28px;
      }
      input {
        margin: 0px 0px 0px 54px !important;
        height: 38px !important;
        background: white;
        border-radius: 20px;
        border:.75px solid rgba(39, 39, 39, 0.29) !important;
        box-shadow: 0px 2px 4px -1px rgba(0, 0, 0, 0.02), 0px 4px 5px 0px rgba(0, 0, 0, 0.04), 0px 1px 10px 0px rgba(0, 0, 0, 0.02) !important;
        width: calc(100% - 32px) !important;
        padding: 0px 16px !important;
      }
    }
    @media screen and (max-width: 680px){
        button.btn {
          margin: 24px 0 0px 55px !important;
          width: 300px;
          float: none !important;
          border-radius: 32px;
        }
      }
  }
}
</style>
<style lang="scss">
.regular-content  {
  p {
    margin-bottom: 8px;
  }
}
#articleView {
  article {
    img {
      max-width: 100%;
      height: auto;
    }
  }
  .active {
    
    .table-of-content {
      height: 0px !important;
      min-height: 0px !important;
      padding: 0px 24px !important;
      margin: 0px !important;
      transition: all 200ms linear ;
    }
  .header-bar {
    border-radius:4px !important;
    &::after {
    content: 'expand_less' !important;
    }
  }
  }
  #toc {
    display: inline-block;
    z-index: 9;
    margin: 0 12px;
    box-shadow: 0px 2px 4px -1px rgba(0, 0, 0, 0.02), 0px 4px 5px 0px rgba(0, 0, 0, 0.04), 0px 1px 10px 0px rgba(0, 0, 0, 0.02);
    background: white;
    @media screen  and (min-width:1024px){
      position: fixed;
      display: inherit;
      bottom: 24px;
      right: 24px;
       margin: 0px;
      width: 350px;
    }
    .header-bar {
      padding: 12px;
      font-size: 18px;
      border-radius: 4px 4px 0 0;
      color: white;
      margin-bottom: 0;
      &::after{
        content: 'expand_more';
        right: 20px;
        position: absolute;
        font-family:'Material Icons';
        font-size: 24px;
        line-height: 27px;
      }
    }
    .table-of-content {
      min-height: 200px;
      transition: all 200ms ease-in ;
      @media screen and (min-width:1024px){
        min-height: 300px;
      }
      overflow: hidden;
      padding:16px 24px 24px;
      margin-bottom: 16px;
      position: relative;
      width: 100%;
      overflow-y: scroll;
      height: 30vh;
      &::-webkit-scrollbar {
        height: 5px;
        background: rgba(184, 184, 184, 0.1);
      }
      &::-webkit-scrollbar-thumb {
        border-radius: 2px;
        background: rgba(184, 184, 184, 0.7);
      }
    }
    }

  .content {
    a {
      color:#3248c2;
    }
    h1 {

    }
    h2 {

    }
    h3 {
      margin-top:16px;
      font-size:24px;
      line-height: 1.4;
      margin-bottom:16px;
    }
    h4 {
      margin-top:16px;
      font-size:22px;
      line-height: 1.4;
      margin-bottom:16px;
    }
    h1, h2, h3, h4, h5 {

    }
    ol {
      margin:10px 0px 16px 0px;
      padding-left:24px;
       li {
         margin-bottom:12px;
       }
    }
    p {
      margin: 2px 0px 12px 0px;
    }
  }
}
</style>